module.exports = __webpack_public_path__ + "static/media/logo-500x500.b857f97a.png";